import React from 'react';

import { LinkedInIcon, InstagramIcon, FacebookIcon } from '@components/icons';
import { ButtonSocialProps } from './ButtonSocialProps';

import * as styles from './ButtonSocial.module.scss';

const iconsMap = {
	facebook: FacebookIcon,
	linkedIn: LinkedInIcon,
	instagram: InstagramIcon,
};

export const ButtonSocial: React.FC<ButtonSocialProps> = ({
	icon,
	url,
	linkTitle,
	...props
}) => {
	const Icon = iconsMap[icon];
	return (
		<a className={styles.link} href={url} {...props} title={linkTitle}>
			<Icon />
		</a>
	);
};
